import { NextSeo } from "next-seo";
import { useUser } from "~/modules/user/hooks/useUser";
import { Navbar } from "~/components/Navbar/component";
import { Routes } from "~/routes";
import { PageTrack } from "~/modules/analytics/components/PageTrack";
import { PageWrapper, SidebarLayout } from "~/components/SidebarLayout";
import { PageHeader } from "~/components/PageHeader";
import { Breadcrumbs } from "~/components/Breadcrumbs";
import { RedirectToLoginWhenNotAuthenticated } from "~/modules/auth/components/RedirectToLoginWhenNotAuthenticated";
import { McpNav } from "~/modules/mcp/components/McpNav";
import { OauthClientsListPage } from "~/modules/oauth_clients/pages/list";
import { FeatureFlag } from "~/modules/feature_flag/components/FeatureFlag";
import { FeatureNames } from "~/modules/feature_flag/flags";

// // // //

export default function OauthClients() {
    const { user } = useUser();
    return (
        <RedirectToLoginWhenNotAuthenticated>
            <FeatureFlag
                feature={FeatureNames.enableMcpTools}
                redirect={Routes.home}
            >
                <PageTrack>
                    <NextSeo title="Settings" />

                    <Navbar user={user} />
                    <SidebarLayout pathname={Routes.toolsMcp} showFooter={true}>
                        <Breadcrumbs
                            pages={[
                                {
                                    name: "Tools",
                                    current: false,
                                },
                                {
                                    name: "MCP",
                                    current: false,
                                    href: Routes.toolsMcp,
                                },
                                {
                                    name: "Settings",
                                    current: true,
                                },
                            ]}
                        />
                        <PageWrapper>
                            <PageHeader title="MCP" />

                            <McpNav page="settings">
                                <OauthClientsListPage />
                            </McpNav>
                        </PageWrapper>
                    </SidebarLayout>
                </PageTrack>
            </FeatureFlag>
        </RedirectToLoginWhenNotAuthenticated>
    );
}
